import { Trans } from '@lingui/react/macro';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBasicCard } from 'noddi-ui-web';
import { compareBookingUpdateDiscountTierThresholds } from 'noddi-util';
import { getTierDiscountLabel, type OfferDiscountTier } from '../../utils/bookingUpdateOfferSectionUtils';
import { formatLocalizedBookingUpdateOfferTierThresholdSummary } from './formatLocalizedBookingUpdateOfferTierThresholdSummary';

interface DiscountTiersListProps {
  tiers: OfferDiscountTier[];
  compact?: boolean;
}

export const DiscountTiersList = ({ tiers, compact }: DiscountTiersListProps) => {
  if (tiers.length === 0) {
    return null;
  }

  const sorted = [...tiers].sort(compareBookingUpdateDiscountTierThresholds);

  return (
    <NoddiBasicCard className='flex flex-col gap-3 border-green-200 bg-green-50'>
      <div className='flex items-center gap-2'>
        <NoddiIcon name='Tag' size='small' className='text-green-700' />
        <p className='text-sm font-medium text-green-900'>
          <Trans>Available discounts</Trans>
        </p>
      </div>
      {compact ? (
        <ul className='flex list-disc flex-col gap-2 pl-5 text-sm text-green-800'>
          {sorted.map((tier) => {
            const threshold = formatLocalizedBookingUpdateOfferTierThresholdSummary(tier);
            const discount = getTierDiscountLabel(tier);
            return (
              <li key={tier.id}>
                {discount != null ? (
                  <Trans>
                    {threshold}: {discount}
                  </Trans>
                ) : (
                  threshold
                )}
              </li>
            );
          })}
        </ul>
      ) : (
        <ul className='flex flex-col gap-2 text-sm'>
          {sorted.map((tier) => {
            const discountText = getTierDiscountLabel(tier);
            return (
              <li
                key={tier.id}
                className='flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 rounded-lg bg-green-100/60 px-3 py-2'
              >
                <span className='text-green-800'>{formatLocalizedBookingUpdateOfferTierThresholdSummary(tier)}</span>
                {discountText != null && <span className='font-semibold text-green-900'>{discountText}</span>}
              </li>
            );
          })}
        </ul>
      )}
    </NoddiBasicCard>
  );
};
